export const ADD_CONTACT_US_REQUEST =   "ADD_CONTACT_US_REQUEST";
export const ADD_CONTACT_US_SUCCESS =   "ADD_CONTACT_US_SUCCESS";
export const ADD_CONTACT_US_FAIL =   "ADD_CONTACT_US_FAIL";
